import { Box, Button, Center, Image, useStyleConfig } from '@chakra-ui/react';
import React from 'react';
import { getEmptySections } from '../utils';
import { getLink, getSectionIndex, getUsefulVars } from '../../../handlers/helpers';
import { onLink } from '../../../handlers';

const CoverLetter = ({ props }) => {
  const uv = getUsefulVars(props);
  const imgSrc = props.navSections['job-posting'].hero;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  return (
    <Box display='flex' flexDirection='column' justifyContent='space-between'>
      <Center>

        <Box className="heroImageBox heroImageLeft" width='50%' margin='1rem 0'>
          <Image className="heroImageImg" src={imgSrc} />
        </Box>
      </Center>
    <Center>
      <Button sx={{...buttonStyles.primary}}
              onClick={() => {
                props.stateProps.onPreviewClose();
                onLink(false, uv.formikProps, uv.stateProps, 'job-posting');
              }}>
        Get Started
      </Button>
      </Center>
    </Box>
  );
};
export default CoverLetter;